import { useLocation, useParams } from 'react-router-dom';

import AoDetailsComponent from '../../../Components/shared/AoDetailsComponent';
import useGetRequest from '../../../hooks/useGetRequest';

function AOdescriptions() {
    let param = useParams();
    let location=useLocation();
    const {data: ao} = useGetRequest({url: `/ao/getMyAoById/${param?.aoId}`,propertyName: 'myAO'});
    return (
        <>
            {ao &&
                <AoDetailsComponent
                    ao={ao}
                    isFromCreateAO={location?.state?.isFromCreateAO}
                />
            }
        </>
    );
}

export default AOdescriptions;